// eslint-disable-next-line import/no-cycle
import actions from './actions';

const state = {
};

export default {
  namespaced: true,
  state,
  //   mutations,
  actions,
};
